// extracted by mini-css-extract-plugin
module.exports = {"footerDesktop":"Footer_footerDesktop__Et_VT"};